// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__tnR6B","containerIcon":"NotFound_containerIcon__S0JWj","content":"NotFound_content__KktgA","btn":"NotFound_btn__v0RmD"};